import ReportDetails from "../components/ReportComponents";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Alert, Grid, Snackbar, Typography } from "@mui/material";
import { useContext } from "react";
import { useReactiveVar } from "@apollo/client/react";
import HeaderSection from "@/components/ReportComponents/HeaderSection";
import { ReportContext } from "@/Contexts/ReportContext";
import { arrayLength } from "@/utils/helperFunctions";
import { displayNotification } from "@/utils/notifications";

const ReportPage: React.FC = () => {
  const notification = useReactiveVar(displayNotification);
  const { projects } = useContext(ReportContext);

  return (
    <Grid container>
      <HeaderSection />
      {arrayLength(projects) > 0 ? (
        <ReportDetails />
      ) : (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          style={{ height: "calc(100vh - 120px)" }}
          size={12}>
          <AssignmentIcon fontSize="large" color="action" />
          <Typography variant="h3" color={"grey.500"}>No projects available</Typography>
        </Grid>
      )}
      <Snackbar
        open={!!notification.text}
        autoHideDuration={6000}
        onClose={() => displayNotification({ type: "", text: "" })}
      >
        <Alert
          onClose={() => displayNotification({ type: "", text: "" })}
          severity={notification.type === "success" ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {notification.text}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default ReportPage;
